module.exports = __webpack_public_path__ + "945e55c712a997636b7ecb1526b05cfd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-yellow-s.png
// module id = 2421
// module chunks = 0